<template>
  <div class="value-field">
    <div class="label">
      {{ label }}
    </div>
    <div class="value">
      <template v-if="typeof value !== 'boolean'">
        <template v-if="typeof value === 'number'">
          {{ value }}
        </template>
        <template v-else>
          <template v-if="value">
            {{ value }}
          </template>
          <template v-else>
            -
          </template>
        </template>
      </template>
      <checkBox v-else :active="value"/>
    </div>
  </div>
</template>

<script>
  import checkBox from './CheckBox'
export default {
  components: {
    checkBox
  },
  props: {
    label: {},
    value: {},
  }
}
</script>

<style lang="scss" scoped>

.value-field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 10px 0;
  border-bottom: 1px solid #C4C4C4;

  .label {
    color: #8E8E8E;
    font-size: 11px;
  }

  .value {
    font-weight: bold;
    font-size: 11px;
  }
}

</style>